import api from './client';

export const getPrinters        = () => api.get('/print-jobs/printers');
export const getPrinterConfig   = () => api.get('/print-jobs/printers/config');
export const setPrinterConfig   = (enabled) => api.put('/print-jobs/printers/config', { enabled });
export const submitPrintJob     = (formData) => api.post('/print-jobs', formData);
export const submitFilePrintJob = (data) => api.post('/print-jobs/from-file', data);
